class TableColumnInfo {
    public ColumnName: string;
    public WidthRatio: number;
    public IsHidden: boolean;
}

export { TableColumnInfo };
